import React, { forwardRef } from 'react'
import { InputNumber } from 'antd'
import './index.css'

interface FormInputNumberProps {
  Form: any;
  label?: React.ReactNode;
  name?: string;
  onChange?: (value: number | string | null) => void;
  placeholder?: string;
  rules?: any[];
  formItemStyles?: React.CSSProperties;
  validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating';
  help?: React.ReactNode;
  onFocusHandler?: () => void;
  onBlurHandler?: () => void;
  autoFocus?: boolean;
  subTextCustom?: React.ReactNode;
  disabled?: boolean;
  smallText?: boolean;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  value?: string | number;
  customFormError?: React.ReactNode;
  [key: string]: any;
}

const FormInputNumber = forwardRef<any, FormInputNumberProps>(
  (
    {
      Form,
      label,
      name,
      onChange,
      placeholder,
      rules = [],
      formItemStyles = {},
      validateStatus,
      help,
      onFocusHandler = () => {},
      onBlurHandler = () => {},
      autoFocus = false,
      subTextCustom = '',
      disabled = false,
      smallText = false,
      onKeyDown = () => {},
      value = '',
      customFormError = false,
      ...extra
    },
    ref,
  ) => {
    let formItemClasses = 'v2FormInput'
    if (subTextCustom) {
      formItemClasses = 'v2FormInput withSubtextCustom'
    }
    if (disabled) {
      formItemClasses = 'v2FormInput disabledInput'
    }
    if (smallText) {
      formItemClasses = 'v2FormInput smallText'
    }
    return (
      <div className="__formInputWrapper">
        <Form.Item
          className={formItemClasses}
          label={label}
          name={name}
          rules={rules}
          style={formItemStyles}
          validateStatus={validateStatus}
          help={help}
        >
          <InputNumber
            autoFocus={autoFocus}
            onFocus={onFocusHandler}
            onBlur={onBlurHandler}
            size="large"
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown}
            disabled={disabled}
            value={value}
            {...extra}
            ref={ref}
          />
        </Form.Item>
        {subTextCustom ? <div className="subTextCustom">{subTextCustom}</div> : ''}
        {customFormError ? <div className="customFormError">{customFormError}</div> : ''}
      </div>
    )
  },
)

export default FormInputNumber
